// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"93":"a05e256e","122":"118a0b5b","242":"fbd7fa4c","267":"af2db9c3","621":"5422ee9b","636":"82c6ce21","681":"be10c4c5","742":"5432ae27","986":"45d61060"}[chunkId] + ".chunk.js";
};